import * as React from "react";
import i18next from "i18next";
import Portal from "../../Popups/Portal";
import { useEffect, useRef, useState } from "react";
import { useBaseMapContext } from "../../Contexts/BaseMapContext";
import { useMapContext } from "../../Contexts/MapContext";
import { ICustomBaseMap } from "./BasemapWidget";
import { SubBaseMapItem } from "./SubBaseMapItem";
import "./ChildMapsPopup.scss";

export interface IChildMapsPopupAnchor {
    element: HTMLDivElement;
    ref: React.RefObject<HTMLDivElement>;
}

export const ChildMapsPopup = (): JSX.Element => {
    const { configA } = useMapContext();
    const { subBasemapConfig, setSubBasemapConfig } = useBaseMapContext();

    const [anchor, setAnchor] = useState({ top: 0, left: 0 });
    const [childBasemaps, setChildBasemaps] = useState(null);
    const [width, setWidth] = useState(0);

    const popupRef = useRef<HTMLDivElement>();

    useEffect(() => {
        document.addEventListener("mouseup", onClickOutside);
        document.addEventListener("pointerup", onClickOutside, false);
        window.addEventListener("resize", onWindowResize);

        return () => {
            document.removeEventListener("mouseup", onClickOutside);
            document.removeEventListener("pointerup", onClickOutside);
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);

    useEffect(() => {
        setChildBasemaps(getChildMaps(configA.basemaps, subBasemapConfig.id));
        const parent =
            document.querySelector("#" + subBasemapConfig.id + "-child") ||
            document.querySelector("#" + subBasemapConfig.id);
        const rect = parent.getBoundingClientRect();
        setAnchor({ top: rect.top, left: rect.left });

        setTimeout(() => {
            if (!popupRef.current) {
                return;
            }
            const popupRect = popupRef.current.getBoundingClientRect();
            let popupWidth = popupRect.width;
            popupRect.width > window.innerWidth && (popupWidth = window.innerWidth);
            width !== popupWidth && setWidth(popupWidth);
        }, 0);
    }, [subBasemapConfig]);

    const getChildMaps = (basemaps: any[], parentMapId: string): any[] =>
        basemaps.filter(
            (basemap: ICustomBaseMap) =>
                basemap.parentId === parentMapId || (basemap.id === parentMapId && basemap.parentId === "")
        );

    const onWindowResize = () => setSubBasemapConfig(null);

    const onClickOutside = (event: MouseEvent | PointerEvent) =>
        !popupRef.current.contains(event.target as Node) && setSubBasemapConfig(null);

    const left =
        (anchor.left + width > window.innerWidth
            ? anchor.left - (anchor.left + width - window.innerWidth) - 1
            : anchor.left) + "px";

    const top = anchor.top - 111 + "px";

    return (
        <Portal id={"child-maps-popup"}>
            <div ref={popupRef} className="child-maps-popup" style={{ left, top }}>
                <div className="child-maps-container">
                    <div className="popup-navigation">
                        <div className="child-maps-close">
                            <button
                                onClick={() => setSubBasemapConfig(null)}
                                className="esri-component esri-widget esri-interactive esri-widget--button esri-icon-close"
                                title={i18next.t("close")}
                            ></button>
                        </div>
                    </div>
                    {childBasemaps ? <ChildMaps childBasemaps={childBasemaps} /> : null}
                </div>
                <div
                    className="arrow-down"
                    style={{
                        left: anchor.left + 23 + "px",
                        top: anchor.top - 5 + "px"
                    }}
                ></div>
            </div>
        </Portal>
    );
};

const ChildMaps = ({ childBasemaps }: { childBasemaps: ICustomBaseMap[] }) => (
    <div className="horizontal-scroll-wrapper">
        <ul className="child-maps-list">
            {childBasemaps.map((basemap: ICustomBaseMap) => (
                <li key={"child_basemap_" + basemap.id} className={"item"}>
                    <SubBaseMapItem
                        key={basemap.id}
                        basemap={basemap}
                        classNameDefault={"basemap"}
                        classNameSelected={"selected-basemap"}
                    />
                </li>
            ))}
        </ul>
    </div>
);
